import { render, staticRenderFns } from "./Pragmem.vue?vue&type=template&id=d67cca38&scoped=true&"
import script from "./Pragmem.vue?vue&type=script&lang=js&"
export * from "./Pragmem.vue?vue&type=script&lang=js&"
import style0 from "./Pragmem.vue?vue&type=style&index=0&id=d67cca38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67cca38",
  null
  
)

export default component.exports